module.exports = __webpack_public_path__ + "img/omil_celeste.27d7ba26.png";